export default "__VITE_ASSET__CNy0yYDV__"